<template>
	<div id="footer" class="container-fluid">
		<div class="logo">
			<img class="logo" :src="cdnImg('logo_black.png')" alt="logo图">
		</div>
		<p class="title">佛山微鲜物互联网服务有限公司</p>
		<p class="address_tel_fax">
			<span>地址：广东省佛山市顺德区容桂街道办事处海尾社区居民委员会茶树西路11号</span>
			<span>Tel：400-116-1238</span>
		</p>
		<p class="email_wx">
			<span>邮箱：fswxwhlwfwyxgs@wxwl1688.com</span>
			<span>微信号：A18100265695</span>
		</p>
		<p class="copy">Copyright &copy; 2018 - {{ new Date().getFullYear() }} 佛山微鲜物互联网服务有限公司</p>
	</div>
</template>
<script>
	export default {
		name: "Footer",
		data() {
			return {};
		}
	};
</script>
<style scoped>
	#footer {
		width: 100%;
		height: 100%;
		color: #fff;
		background: #474747;
		overflow: hidden;
		text-align: center;
	}

	.logo {
		/* width: 95px; */
		height: 45px;
		margin: 50px auto 20px;
	}

	.title {
		font-size: 25px;
		margin-bottom: 20px;
	}

	.address_tel_fax {
		color: #d3d3d3;
		font-size: 14px;
		margin: 10px 0;
	}

	.email_wx {
		color: #d3d3d3;
		font-size: 14px;
	}

	.copy {
		color: #d3d3d3;
		font-size: 14px;
		margin: 50px 0 10px;
	}

	@media screen and (max-width: 997px) {
		.title {
			font-size: 20px;
		}

		.address_tel_fax {
			font-size: 12px;
		}

		.email_wx {

			font-size: 12px;
		}

		.copy {
			font-size: 12px;
			margin: 30px 0 10px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue